"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "VictorySharedEvents", {
  enumerable: true,
  get: function () {
    return _victorySharedEvents.default;
  }
});

var _victorySharedEvents = _interopRequireDefault(require("./victory-shared-events"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/victory-shared-events/lib/index.js
// module id = 215
// module chunks = 0